export enum AuroraBoilerMainPowerStatus {
  ON = 'on',
  OFF = 'off'
}

export default AuroraBoilerMainPowerStatus
